import { gql } from '@apollo/client';
import type { CommentThreadPath_ThreadFragment } from '../../graphql/generated/graphqlTypes';
import postPath from './postPath';

const THREAD_FRAGMENT = gql`
  fragment commentThreadPath_thread on Thread {
    id
    resolvedAt
    post {
      ...postPath_post
    }
  }
  ${postPath.fragments.post}
`;

const commentThreadPath = (thread: CommentThreadPath_ThreadFragment) =>
  thread.post
    ? `${postPath(thread.post)}${thread.resolvedAt ? '/comments' : ''}#thread-${
        thread.id
      }`
    : undefined;

commentThreadPath.fragments = { thread: THREAD_FRAGMENT };

export default commentThreadPath;
